import {
  IonAvatar,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonPage,
  IonSpinner,
  IonTitle,
  IonToolbar,
  useIonViewWillEnter
} from "@ionic/react";
import { checkmark, chevronBack } from "ionicons/icons";
import { useParams } from "react-router-dom";
import { useQuestsStore } from "../stores/quests.store";
import { useState } from "react";
import { useHistory } from "react-router";
import CircularProgressBar from "../components/CircularProgressBar";
import UserName from "../components/UserName";
import { ReactComponent as TradesIcon } from "../assets/graphics/mode_heat.svg";
import { ReactComponent as StreaksIcon } from "../assets/graphics/mode_streaks.svg";
import QuoQuestResultModal, {
  ResultModalProps
} from "../components/QuoQuestResultModal";
import { useActiveBot } from "../hooks/useActiveBot";
import { useLobbiesStore } from "../stores/lobbies.store";
import BotListComponent from "../components/BotList";
import { calculateProgress } from "../utils/botUtils";
import ChallengeSummary from "../components/ChallengeSummary";

const QuoQuestLevelStageGame = () => {
  const history = useHistory();
  const { levelId, stageIndex, lobbyId } = useParams<{
    levelId: string;
    stageIndex: string;
    lobbyId: string;
  }>();
  const [lobby] = useLobbiesStore(state => [
    state.lobbies.find(l => l.id === lobbyId)
  ]);
  const levels = useQuestsStore(state => state.levels);
  // Inner state changes aren't triggered by updateLevelStage in state as it modifies "levels" on state
  // We must therefore listen to levels on state and get derived level in the component
  const level = levels.find(lvl => lvl.level === +levelId);

  const { activeBot, userBot, profile } = useActiveBot();

  const [isLoading, setIsLoading] = useState(true);
  const [isDoneSettingUp, setIsDoneSettingUp] = useState(false);
  const [isDoneInitialisingQuest, setIsDoneInitialisingQuest] = useState(false);
  const [isHistoricalDataReady, setIsHistoricalDataReady] = useState(false);

  // TODO: Note: Leaving this here as progress is not working
  // const [progress, setProgress] = useState(0);

  const [isResultOpen, setIsResultOpen] = useState(false);
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [result, setResult] = useState<ResultModalProps>({
    levelName: level?.levelName ?? "",
    didPass: false,
    attemptsLeft: level?.stages[stageIndex ? +stageIndex : 0].attemptsLeft ?? 0,
    isLevelUp: [5, 11, 15].includes(level?.level ?? 1),
    level: level?.level ?? 1,
    unlockedFeature:
      level?.stages[stageIndex ? +stageIndex : 0].featureUnlock ?? "",
    buttons: [],
    isOpen: false,
    onDismiss: () => setIsResultOpen(false)
  });

  const progress = userBot
    ? calculateProgress(
        userBot.totalTimestamp,
        userBot.backtestConfig?.startTime,
        userBot.backtestConfig?.endTime
      )
    : 0;

  // TODO: Replace with on network resolve/state update
  const restartGame = () => {
    setIsDoneSettingUp(false);
    setIsDoneInitialisingQuest(false);
    setIsHistoricalDataReady(false);
    // setProgress(0);
    setIsLoading(true);
    setIsSummaryOpen(false);
    setTimeout(() => {
      setIsDoneSettingUp(true);
    }, 1300);
    setTimeout(() => {
      setIsDoneInitialisingQuest(true);
    }, 1800);
    setTimeout(() => {
      setIsHistoricalDataReady(true);
      setIsLoading(false);
      // setProgress(10);
    }, 2450);
    // setTimeout(() => {
    //   setProgress(38);
    // }, 3680);
    // setTimeout(() => {
    //   setProgress(49);
    // }, 4780);
    // setTimeout(() => {
    //   setProgress(68);
    // }, 5980);
    // setTimeout(() => {
    //   setProgress(89);
    // }, 7800);
    // setTimeout(() => {
    //   setProgress(100);
    // }, 8000);
  };

  // We can't have the old state live on after navigating away - probably a router fix, but I can't find it
  useIonViewWillEnter(() => restartGame());

  const goToNextThing = () => {
    // if fail
    // big sad modal + lottie
    // else
    // if last stage
    // level up! Next / summary
    // else
    // well done, next / summary
    const didPass = stageIndex
      ? level?.stages[+stageIndex].hasCleared ?? false
      : false;
    setResult({
      ...result,
      didPass,
      buttons: [
        didPass
          ? {
              type: "solid",
              text: "Next Task",
              link: "/quest/levels"
            }
          : {
              type: "solid",
              text: "Try Again",
              action: () => history.goBack()
            },
        {
          type: "outline",
          text: "View Summary",
          action: () => setIsSummaryOpen(true)
        },
        {
          type: "clear",
          text: "Exit",
          link: "/"
        }
      ]
    });
    setIsResultOpen(true);
  };

  if (!level || !lobby) {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton routerLink="/quest/levels">
                <IonIcon className="text-white" icon={chevronBack} />
              </IonButton>
            </IonButtons>
            <IonTitle className="capitalize font-normal pt-4">
              Quest {levelId}
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>Error, please go back.</IonContent>
      </IonPage>
    );
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon className="text-white" icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle className="capitalize font-normal pt-4">
            Quest {levelId}: {level?.levelName}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {!isSummaryOpen ? (
          <div className="h-full flex flex-col items-center bg-primary-90">
            <div className="pt-40 w-full bg-blue-500 bg-gradient-to-b from-primary-90 to-primary-70"></div>
            <div className="flex flex-col items-center">
              <IonAvatar className="h-40 w-40 p-4 -mt-20 bg-primary-90 relative">
                <IonImg src={userBot ? userBot?.img : activeBot.img} />
                <div className="absolute inset-0">
                  <CircularProgressBar percentage={progress} sqSize={160} />
                </div>
              </IonAvatar>
              <div className="text-3xl font-bold pt-2">
                {userBot ? userBot?.name : activeBot.name}
              </div>
              {profile && <UserName userId={profile?.userId} />}
            </div>
            <div className="flex flex-col w-full items-center mt-5">
              <div className="flex w-full justify-around">
                {["profit", "trades", "streak"].map((key, index) => (
                  <div key={index} className=" uppercase text-xs text-gray-400">
                    {key}
                  </div>
                ))}
              </div>
              <div className="flex justify-around w-full mt-2">
                <div
                  className={`flex items-center justify-center bg-opacity-70 px-8 rounded-lg w-1/3 mx-2 text-center ${
                    userBot && userBot?.profit < 0
                      ? "bg-red-800 text-red-400"
                      : "bg-green-800 text-green-400"
                  }`}
                >
                  <span className="font-bold">
                    {userBot?.profit?.toFixed(2) || 0}%
                  </span>
                </div>
                <div className="flex items-center justify-center bg-orange-800 bg-opacity-70 px-8 rounded-lg text-orange-500 w-1/3 mx-2 text-center">
                  <div className="bg-[#ff7f0a] p-[2px] rounded h-4 mr-2">
                    <TradesIcon />
                  </div>
                  <span className="font-bold">{userBot?.tradeCount || 0}</span>
                </div>
                <div className="flex items-center justify-center bg-blue-800 bg-opacity-70 px-2 rounded-lg text-blue-500 w-1/3 mx-2 text-center py-2">
                  <div className="bg-blue-600 p-[2px] p rounded h-4 mr-2">
                    <StreaksIcon />
                  </div>
                  <span className="font-bold">
                    {userBot?.profitStreak || 0} /{" "}
                    {userBot?.maxProfitStreak || 0}
                  </span>
                </div>
              </div>
            </div>

            {/* Loading indicator */}
            {isLoading ? (
              <div className="flex flex-col mt-8 w-full px-4">
                <div className="flex items-center w-full border-b border-gray-700 py-2">
                  <IonIcon
                    icon={checkmark}
                    className="bg-green-500 rounded-full text-primary-80 mr-2 w-5 h-5"
                  />
                  Challenge Accepted!
                </div>
                <div className="flex items-center w-full py-2">
                  {isDoneSettingUp ? (
                    <IonIcon
                      icon={checkmark}
                      className="bg-green-500 rounded-full text-primary-80 mr-2 w-5 h-5"
                    />
                  ) : (
                    <IonSpinner
                      className="bg-green-500 rounded-full text-primary-80 mr-2 w-5 h-5"
                      name="crescent"
                    />
                  )}
                  Setting up
                </div>
                <div className="text-sm pl-8 border-b border-gray-700 pb-2">
                  <div
                    className={
                      "flex justify-between " +
                      (!isDoneInitialisingQuest ? "text-gray-600" : "")
                    }
                  >
                    Initialising the quest
                    <IonIcon
                      icon={checkmark}
                      className={
                        "text-lg " +
                        (isDoneInitialisingQuest ? "text-green-500" : "")
                      }
                    />
                  </div>
                  <div
                    className={
                      "flex justify-between " +
                      (!isHistoricalDataReady ? "text-gray-600" : "")
                    }
                  >
                    Populating historical trade data
                    <IonIcon
                      icon={checkmark}
                      className={
                        "text-lg " +
                        (isHistoricalDataReady ? "text-green-500" : "")
                      }
                    />
                  </div>
                </div>
                <div className="flex items-center w-full border-b border-gray-700 py-2">
                  <IonIcon
                    icon={checkmark}
                    className={
                      "rounded-full text-primary-80 mr-2 w-5 h-5 " +
                      (isDoneSettingUp &&
                      isDoneInitialisingQuest &&
                      isHistoricalDataReady
                        ? "bg-green-500"
                        : "bg-gray-600")
                    }
                  />
                  Quest Started!
                </div>
              </div>
            ) : (
              <div>
                <div className="text-xl px-4 py-2 font-bold">Standings</div>
                {lobby && <BotListComponent lobbyId={lobby.id} />}
              </div>
            )}
            {lobby.ended && (
              <div className="w-full mt-auto mb-4 px-2">
                <IonButton
                  color="primary"
                  className="h-16 text-base"
                  expand="block"
                  onClick={() => goToNextThing()}
                >
                  Next
                </IonButton>
              </div>
            )}
          </div>
        ) : (
          <div className="h-full">
            <ChallengeSummary
              lobby={lobby}
              completeChallenge={() => history.push("/quest/levels")}
            />
          </div>
        )}
        <QuoQuestResultModal {...result} isOpen={isResultOpen} />
      </IonContent>
    </IonPage>
  );
};
export default QuoQuestLevelStageGame;
